(() => {
  if (customElements.get('sensora-cart-coupon')) return;
  let busy = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const strings = () => window.sensoraCouponStrings || {};
  const codes = cart => (cart.discount_codes || []).map(d => d.code).filter(Boolean);
  const applied = (cart, code) => (cart.discount_codes || []).some(d => d.code?.toUpperCase() === code.toUpperCase() && d.applicable === true) || (cart.cart_level_discount_applications || []).some(d => d.type === 'discount_code' && d.title?.toUpperCase() === code.toUpperCase());
  async function json(url, options) {
    const response = await fetch(url, { credentials: 'same-origin', ...options });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error('cart_request_failed');
    return data;
  }
  class SensoraCartCoupon extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', e => e.stopPropagation());
      this.addEventListener('input', e => e.stopPropagation());
      this.querySelector('[data-coupon-apply]').addEventListener('click', () => this.update());
      this.querySelector('[data-coupon-input]').addEventListener('keydown', e => {
        if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); this.update(); }
      });
      this.querySelectorAll('[data-coupon-remove]').forEach(button => button.addEventListener('click', () => this.update(button.dataset.couponRemove)));
    }
    message(text, success = false) {
      const message = this.querySelector('[data-coupon-message]');
      message.textContent = text;
      message.classList.toggle('is-success', success);
    }
    async update(removeCode) {
      if (busy) return;
      const input = this.querySelector('[data-coupon-input]');
      const code = input.value.trim();
      if (!removeCode && !code) { this.message(strings().empty); input.focus(); return; }
      busy = true;
      this.setAttribute('aria-busy', 'true');
      const context = this.dataset.context;
      const controls = [...document.querySelectorAll('cart-drawer button, cart-drawer input, #main-cart-footer button, cart-items input, cart-items button')];
      const states = controls.map(control => control.disabled);
      controls.forEach(control => control.disabled = true);
      this.message(strings().busy, true);
      let resultMessage = strings().error;
      let success = false;
      try {
        const current = await json(root() + 'cart.js');
        let existing = codes(current);
        if (!existing.length) existing = (current.cart_level_discount_applications || []).filter(d => d.type === 'discount_code').map(d => d.title);
        const desired = removeCode ? existing.filter(c => c.toUpperCase() !== removeCode.toUpperCase()) : [...new Set([...existing, code])];
        const pageFooter = document.querySelector('#main-cart-footer');
        const sections = ['cart-drawer', 'cart-icon-bubble'];
        if (pageFooter?.dataset.id) sections.push(pageFooter.dataset.id);
        const cart = await json(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: desired.join(','), sections, sections_url: location.pathname + location.search })
        });
        success = removeCode ? !applied(cart, removeCode) : applied(cart, code);
        resultMessage = success ? (removeCode ? strings().removed : strings().applied) : strings().invalid;
        const drawer = document.querySelector('cart-drawer');
        if (context === 'drawer' && drawer && sections.slice(0,2).every(id => typeof cart.sections?.[id] === 'string')) {
          drawer.renderContents(cart);
        } else if (drawer && typeof cart.sections?.['cart-drawer'] === 'string') {
          const parsed = new DOMParser().parseFromString(cart.sections['cart-drawer'], 'text/html');
          const next = parsed.querySelector('#CartDrawer');
          if (next) drawer.querySelector('#CartDrawer').innerHTML = next.innerHTML;
          drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
        }
        if (pageFooter) {
          const html = cart.sections?.[pageFooter.dataset.id];
          const next = html && new DOMParser().parseFromString(html, 'text/html').querySelector('#main-cart-footer');
          if (next) pageFooter.innerHTML = next.innerHTML;
          else if (context === 'page') throw new Error('cart_render_failed');
        }
        if (typeof cart.sections?.['cart-icon-bubble'] === 'string') {
          const next = new DOMParser().parseFromString(cart.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (next) document.querySelector('#cart-icon-bubble').innerHTML = next.innerHTML;
        }
        if (context === 'drawer' && !cart.sections?.['cart-drawer']) throw new Error('cart_render_failed');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sensora-coupon', cartData: cart });
      } catch (error) {
        resultMessage = strings().error;
        success = false;
      } finally {
        controls.forEach((control, i) => { if (control.isConnected) control.disabled = states[i]; });
        busy = false;
        this.removeAttribute('aria-busy');
        const target = [...document.querySelectorAll('sensora-cart-coupon')].find(el => el.dataset.context === context) || this;
        target.message(resultMessage, success);

        target.querySelector('[data-coupon-message]').focus({ preventScroll: true });
      }
    }
  }
  document.addEventListener('click', e => {
    if (busy && e.target.closest('cart-drawer, cart-items, #main-cart-footer, .sensora-home-purchase')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', e => {
    if (busy && (e.target.id === 'cart' || e.target.id === 'CartDrawer-Form')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  customElements.define('sensora-cart-coupon', SensoraCartCoupon);
})();